import { useEffect, useState } from "react";
import { ExternalLink, Loader2 } from "lucide-react";
import { api } from "@/lib/api";

export default function PinterestEmbed({ boardUrl }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!boardUrl) return;
    let cancelled = false;
    (async () => {
      try {
        setLoading(true);
        setError(false);
        const r = await api.get("/pinterest/preview", { params: { url: boardUrl } });
        if (!cancelled) setData(r.data);
      } catch {
        if (!cancelled) setError(true);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, [boardUrl]);

  if (!boardUrl) return null;

  return (
    <div className="w-full max-w-sm mx-auto">
      <a href={boardUrl} target="_blank" rel="noreferrer" className="block relative rounded-2xl overflow-hidden bg-sand shadow-md hover:shadow-xl transition-shadow duration-500" data-testid="pinterest-preview-link">
        {loading ? (
          <div className="min-h-[240px] grid place-items-center">
            <Loader2 className="animate-spin text-warmgold" size={22} />
          </div>
        ) : data?.image ? (
          <div className="relative">
            {/* Full image visible (no crop) */}
            <img src={data.image} alt={data.title || "Pinterest board"} className="block w-full h-auto object-contain" />
            {data.title && (
              <div className="p-4 border-t border-warmgold/15 bg-white/70 text-center">
                <p className="text-[10px] uppercase tracking-widest text-warmgold">Tablero</p>
                <p className="fn-body-font text-lg text-ink leading-tight mt-1 line-clamp-2">{data.title.replace(/\s+\|.*$/,"")}</p>
              </div>
            )}
          </div>
        ) : error ? (
          <div className="min-h-[160px] grid place-items-center p-6 text-center">
            <p className="text-sm text-inksoft">No se pudo cargar el tablero. Toca para abrirlo en Pinterest.</p>
          </div>
        ) : null}
      </a>
      <div className="text-center mt-3">
        <a href={boardUrl} target="_blank" rel="noreferrer" className="text-warmgold text-sm inline-flex items-center gap-1 hover:underline" data-testid="pinterest-open">
          Ver tablero completo <ExternalLink size={12} />
        </a>
      </div>
    </div>
  );
}
